"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (obj) {
  var values = [];
  Object.keys(obj).forEach(function (key) {
    return values.push(obj[key]);
  });
  return values;
};


//////////////////
// WEBPACK FOOTER
// ./~/react-toastify/lib/util/objectValues.js
// module id = ./node_modules/react-toastify/lib/util/objectValues.js
// module chunks = 114276838955818 137591856104208 276150767547794